//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('batchDelReceiveLine', {
//        templateUrl: 'views/components/views/batchDelReceiveLine/batchDelReceiveLine.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'batchDelReceiveLineService', function ($stateParams, stateService, translateService, modalService, batchDelReceiveLineService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let batchDelReceiveLineKeyno = $stateParams.batchdelreceiveline_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                info: {},
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadInfo() {
//                vm.model.info = (await batchDelReceiveLineService.getInfo({ batchdelreceiveline_keyno: batchDelReceiveLineKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    batchDelReceiveLineService.deleteItem(vm.model.info).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: function (dialogItself) {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadInfo();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
